module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerCommon"
  }, [_c('div', {
    staticClass: "header",
    class: {
      IsFixed: this.searchBarFixed
    },
    on: {
      "mouseenter": function($event) {
        return _vm.headerEnter(_vm.fixFlag)
      },
      "mouseleave": function($event) {
        return _vm.headerOut(_vm.fixFlag)
      },
      "touchstart": function($event) {
        return _vm.headerEnter(_vm.fixFlag)
      }
    }
  }, [_c('div', {
    staticClass: "clearfix rel header-content"
  }, [_c('a', {
    staticClass: "header-logo cp",
    attrs: {
      "href": _vm.goSelf('/index')
    }
  }, [(this.searchBarFixed) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/index/logo_new.svg"),
      "alt": "logo"
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/index/logo_white.svg"),
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-title"
  }, [_c('div', {
    staticClass: "header-nav"
  }, [_c('ul', {
    staticClass: "clearfix header-nav-ul"
  }, _vm._l((_vm.headerNav), function(item, index) {
    return (_vm.headerNav.length > 0) ? _c('li', {
      key: index,
      staticClass: "header-nav-li"
    }, [_c('a', {
      staticClass: "cp nav-item",
      class: item.status === '0' ? 'dn' : 'db',
      attrs: {
        "href": _vm.goSelf(item.link)
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.status === '1' && item.s.length > 0 && _vm.searchBarFixed) ? _c('div', {
      staticClass: "collapse"
    }, [_c('div', {
      staticClass: "collapse-w"
    }, [_c('ul', {
      staticClass: "clearfix collapse-ul"
    }, _vm._l((item.s), function(list, idex) {
      return _c('li', {
        key: idex,
        staticClass: "collapse-ul-li"
      }, [_c('div', {
        staticClass: "clearfix car-collapse-title"
      }, [_c('div', {
        staticClass: "fl icon"
      }, [(list.name === '产品套件') ? _c('img', {
        attrs: {
          "src": require("../../assets/img/header/icon2.png"),
          "alt": "产品套件"
        }
      }) : _vm._e(), _vm._v(" "), (list.name === '甄采云') ? _c('img', {
        attrs: {
          "src": require("../../assets/img/header/icon1.png"),
          "alt": "甄采云"
        }
      }) : _vm._e(), _vm._v(" "), (list.name === '系统 / 平台集成') ? _c('img', {
        attrs: {
          "src": require("../../assets/img/header/icon4.png"),
          "alt": "系统 / 平台集成"
        }
      }) : _vm._e(), _vm._v(" "), (list.name === '我的角色') ? _c('img', {
        attrs: {
          "src": require("../../assets/img/header/icon3.png"),
          "alt": "我的角色"
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "fl title",
        class: list.status === '0' ? 'dn' : 'db'
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (list.status === '1' && list.s.length > 0),
          expression: "list.status === '1' && list.s.length >0"
        }],
        staticClass: "noHover list-name"
      }, [_vm._v(_vm._s(list.name) + "\n                          ")]), _vm._v(" "), _c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (list.status === '1' && list.s.length === 0),
          expression: "list.status === '1' && list.s.length === 0"
        }],
        staticClass: "cp normal",
        attrs: {
          "href": _vm.goSelf(list.link)
        }
      }, [_vm._v(_vm._s(list.name))])])]), _vm._v(" "), (list.s.length > 0 && list.status === '1') ? _c('div', {
        staticClass: "item-list"
      }, _vm._l((list.s), function(nav, id) {
        return _c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (nav.status === '1'),
            expression: "nav.status === '1'"
          }],
          key: id,
          staticClass: "cp item-list-a",
          attrs: {
            "href": _vm.goSelf(nav.link)
          }
        }, [_c('span', [_vm._v(_vm._s(nav.name))])])
      }), 0) : _vm._e()])
    }), 0)])]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "header-tel"
  }, [_c('span', {
    staticClass: "span-one",
    class: {
      IsColor: this.searchBarFixed
    }
  }, [_vm._v("服务热线：400-116-0808")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "span-two"
  }, [_c('span', [_vm._v("CH")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('span', [_vm._v("EN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-right-code"
  }, [_c('span', {
    staticClass: "header-right-code-text"
  }, [_vm._v("获取资料")]), _vm._v(" "), _c('div', {
    staticClass: "header-right-code-img"
  }, [_c('div', {
    staticClass: "header-right-code-img-triangle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-right-img-wei"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcc0a7ca"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header.vue
// module id = 272
// module chunks = 12